var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Lock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.875C7.59766 1.875 5.625 3.84766 5.625 6.25V8.125H3.75V18.125H16.25V8.125H14.375V6.25C14.375 3.84766 12.4023 1.875 10 1.875ZM10 3.125C11.7212 3.125 13.125 4.52881 13.125 6.25V8.125H6.875V6.25C6.875 4.52881 8.27881 3.125 10 3.125ZM5 9.375H15V16.875H5V9.375Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Lock);
export default __webpack_public_path__ + "static/media/icons8-lock.4da3c31041f0b34805ff46fa8d67754d.svg";
export { ForwardRef as ReactComponent };